import React, { useEffect, useState } from 'react';
import io from 'socket.io-client';
import { BiSend } from 'react-icons/bi';
import '../../../styles/Admin/Admin_Chat/admin_chat.css';
import { v4 as uuid } from 'uuid';
import { BASE_URL } from '../../../settings';

// const socket = io.connect(BASE_URL);
let socket;

// 👇️ dummy messages
const dummyMessages = [
    {
        id: uuid(),
        time: new Date(),
        name: 'Me',
        text: 'Hello, there!',
    },
    {
        id: uuid(),
        time: new Date(),
        name: 'Ashley',
        text: 'Hey!, how are you? 👋',
    },
];

export default function Admin_AlumniChat({ fetched_alumni }) {
    const [message, setMessage] = useState();
    const [messages, setMessages] = useState(dummyMessages);
    const username = fetched_alumni?.username;

    // 👇️ component will mount
    // useEffect(() => {
    //     if (socket) {
    //         socket.on('new-message', (data) => {
    //             console.log('\nreceived a new message:', data);
    //             alert('yeah!!!!');
    //         });
    //     }
    // }, []);

    // 👇️ handler to add alumni to room
    const joinAlumniToRoom = () => {
        if (socket) {
            socket.emit('join-room', { username });
        }
        console.log('socket:', socket);
    };

    // 👇️ handler to send new message
    const sendMessage = () => {
        if (message) {
            let msg = {
                text: message,
                time: new Date(),
                id: uuid(),
                name: 'Me',
            };
            setMessages([...messages, msg]);
            setMessage('');
            if (socket) {
                socket.emit('new-message', { message: msg });
            }
        }
    };

    // 👇️ handler to delete message
    const deleteMessage = (msg) => {
        let filterdMessages = messages.filter((item) => item?.id !== msg?.id);
        setMessages(filterdMessages);
    };

    return (
        <div className='admin-alumni-chat-container'>
            <h1 className='header-text'>Chat with @{username || 'username'}</h1>

            <button onClick={joinAlumniToRoom}>Join @{username} to chat</button>

            <div className='messages'>
                <div className='messages-container'>
                    {/* <span className='update'>Today at 12:03</span> */}

                    {messages.map((item, index) => (
                        <div
                            className={`message-item ${item?.name === 'Me' ? 'me' : 'other'}`}
                            key={`message-item-#${index}-${item?.id}`}
                        >
                            <div className='header'>
                                <span className='name'>@{item?.name}</span>
                                <span className='time'>
                                    {item?.time?.toTimeString()?.slice(0, 5)}
                                </span>
                            </div>

                            <span className='text'>{item?.text || '...'}</span>
                        </div>
                    ))}
                </div>

                <div className='message-input-container'>
                    <input
                        type='text'
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        placeholder='new message...'
                        name='message'
                    />
                    <BiSend onClick={sendMessage} className='send-button' color='white' size={50} />
                </div>
            </div>
        </div>
    );
}
